var Headboard = /** @class */ (function () {
    function Headboard(props) {
        Object.assign(this, props);
        if (props.disabled_at)
            this.disabled_at = new Date(props.disabled_at);
    }
    return Headboard;
}());
export default Headboard;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Headboards/Headboard.ts
// module id = 326
// module chunks = 0